import React from 'react'
import styled from 'styled-components';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import Fade from 'react-reveal/Fade';
import Rotate from 'react-reveal/Rotate';
import Roll from 'react-reveal/Roll';
import Slide from 'react-reveal/Slide';
import Flip from 'react-reveal/Flip';

const Container = styled.div`
    display:grid;
    grid-template-columns:repeat(auto-fill,440px);
    width:80vw;
    justify-content:center;
    ${'' /* max-width:1200px; */}
`
const LeftColumn = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:center;
    height:600px;
    width:400px;
    margin:10px 40px;
    padding:20px 40px;
    box-shadow:0 -1px 4px 0 rgb(26 26 26 / 8%), 0 4px 8px 0 rgb(26 26 26 / 12%);
`
const Img = styled.img`
    height:auto;
    width:250px;
    margin-bottom:50px;
    object-fit:cover;
`

const RightColumn = styled.div`
    height:600px;
    width:400px;
    margin:10px 40px;
    padding:20px 40px;
    box-shadow:0 -1px 4px 0 rgb(26 26 26 / 8%), 0 4px 8px 0 rgb(26 26 26 / 12%);

`

const Resume = () => {
    return (
        <Container>
            <Fade left>
                <LeftColumn>
                <Roll left>
                <Img src="https://avatars.githubusercontent.com/u/24513658?s=400&u=4b57ef944d1d54524b4b94c04084db3134ff4429&v=4" alt='im' />
                    </Roll>
                    <Flip left>
                    <span>NDIAYE MOUHAMADOU</span>
                        <h4> <LocationOnIcon /> 95301 ST-OUEN L'AUOMNE,France</h4>
                    </Flip>
                    <Slide right>
                        <h3>Learn and Be Curious</h3>
                    </Slide>
                    <Roll bottom>
                    <p>I have to recognize that my biggest weakness is Curiosity,
                        besides my statistics background I have jumped into various
                        fields like electronics (signal processing )
                        and AI (ML Deep Learning) and now I'm focusing
                        on web development and AI.</p>
                    </Roll>
                </LeftColumn>
            </Fade>
            <Fade right>
            <RightColumn>
                <Rotate top left>
                    <h3> <FiberManualRecordIcon /> Web development</h3>
                </Rotate>
                <Fade left>
                    <h4><ArrowRightIcon /> JavaScript</h4>
                </Fade>
                <Fade right>
                    <h4><ArrowRightIcon /> React-Js</h4>
                </Fade>
                <Fade left>
                    <h4><ArrowRightIcon /> HTML</h4>
                </Fade>
                <Fade right>
                    <h4><ArrowRightIcon /> CSS </h4>
                </Fade>
                <Fade left>
                    <h4><ArrowRightIcon /> firebase</h4>
                </Fade>
                <Rotate top left>
                    <h3> <FiberManualRecordIcon /> Statistics and ML</h3>
                </Rotate>
                <Fade right>
                    <h4><ArrowRightIcon /> Python</h4>
                </Fade>
                <Fade left>
                    <h4><ArrowRightIcon /> Deep Learning</h4>
                </Fade>
                <Fade right>
                    <h4><ArrowRightIcon /> SQL</h4>
                </Fade>
                <Fade left>
                    <h4><ArrowRightIcon /> Statistics</h4>
                </Fade>
                </RightColumn>
            </Fade>
        </Container>
    )
}

export default Resume
